import React, { useState } from "react";
import Layout from "./Layout";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { t } from "i18next";
import { isEmpty } from "lodash";
import { isMobile } from "react-device-detect";

const Login = () => {
  const loginUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.loginUser;
  });

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(true);
  const handleShow = () => {
    setShowPassword(!showPassword);
  };
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    unregister,
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
  });

  const onSubmit = (data) => {
    loginUser(data);
  };
  return (
    <Layout>
      <div className="body">
        <div
          className="row no-gutters"
          openregisterdialog="function(){}"
          openlanguagedialog="function(){}"
        >
          <div className={`col col-12 login_panel ${!isMobile ? "px-5" : ""}`}>
            <div className="row hidden-md-and-up" style={{ margin: "unset" }}>
              <div className="mobile-header text-center col col-12">
                {t("LoginToBabu88")}
              </div>
            </div>
            <div
              className="row hidden-sm-and-down mt-4"
              style={{ margin: "unset" }}
            >
              <div className="login-header text-center py-0 col col-12">
                {t("Login")}
              </div>
              <div className="login-header-desc text-center pt-0 col col-12">
                {t("WelcomeBack")}
              </div>
            </div>
            <div
              className={`row justify-center ${!isMobile ? "mt-2 mb-6" : ""}`}
            >
              <div
                className={`col-md-4 col-12 ${
                  !isMobile ? "login-form-bg pt-0 mb-12" : ""
                }`}
              >
                <Form onSubmit={handleSubmit(onSubmit)} className="v-form ma-8">
                  <div className="row justify-center">
                    <div className="col col-12">
                      <div className={isMobile ? "mobile" : ""}>
                        <div className="row no-gutters justify-space-between">
                          <div className="col col-10">
                            <label
                              className={`input-field-label ma-0 text-capitalize d-block pb-${
                                isMobile ? "1" : "2"
                              }`}
                              style={{ float: "left" }}
                            >
                              {t("Username")}
                              <span className="red--text ml-1">*</span>
                            </label>
                          </div>
                          <div className="col col-2">
                            <i
                              aria-hidden="true"
                              aria-haspopup="true"
                              aria-expanded="false"
                              className="v-icon notranslate material-icons theme--light primary--text"
                              style={{ float: "right" }}
                            >
                              help
                            </i>
                            <span className="v-tooltip v-tooltip--right">
                              {/**/}
                            </span>
                          </div>
                          <div className="col col-12">
                            <div
                              // theme--light
                              className={`v-input input-field elevation-0 hide-details  v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder ${
                                !isEmpty(errors.username)
                                  ? "error--text v-input--has-state"
                                  : ""
                              } `}
                            >
                              <div className="v-input__control">
                                <div className="v-input__slot">
                                  <fieldset aria-hidden="true">
                                    <legend style={{ width: "0px" }}>
                                      <span className="notranslate">​</span>
                                    </legend>
                                  </fieldset>
                                  <div className="v-text-field__slot">
                                    <input
                                      // autoComplete="new-password"
                                      id="input-313"
                                      style={{ color: "black" }}
                                      placeholder={t("Username")}
                                      type="text"
                                      {...register("username", {
                                        required: t("Enter_Username"),
                                      })}
                                    />
                                  </div>
                                </div>{" "}
                                {errors.username && errors.username.message && (
                                  <div className="v-text-field__details">
                                    <div
                                      className="v-messages theme--light error--text"
                                      role="alert"
                                    >
                                      <div className="v-messages__wrapper">
                                        <div className="v-messages__message">
                                          {errors.username.message}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mobile">
                        <div className="row no-gutters justify-space-between">
                          <div className="col col-10">
                            <label
                              className="input-field-label ma-0 text-capitalize d-block pb-1"
                              style={{ float: "left" }}
                            >
                              {t("Password")}
                              <span className="red--text ml-1">*</span>
                            </label>
                          </div>
                          <div className="col col-2">
                            <i
                              aria-hidden="true"
                              aria-haspopup="true"
                              aria-expanded="false"
                              className="v-icon notranslate material-icons theme--light primary--text"
                              style={{ float: "right" }}
                            >
                              help
                            </i>
                            <span className="v-tooltip v-tooltip--right">
                              {/**/}
                            </span>
                          </div>
                          <div className="col col-12">
                            <div
                              className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder ${
                                !isEmpty(errors.password)
                                  ? "error--text v-input--has-state"
                                  : ""
                              } `}
                            >
                              <div className="v-input__control">
                                <div className="v-input__slot">
                                  <fieldset aria-hidden="true">
                                    <legend style={{ width: "0px" }}>
                                      <span className="notranslate">​</span>
                                    </legend>
                                  </fieldset>
                                  <div className="v-text-field__slot">
                                    <input
                                      // autoComplete="new-password"
                                      id="input-319"
                                      placeholder={t("Password")}
                                      {...register("password", {
                                        required: t("Enter_Password"),
                                        minLength: {
                                          value: 6,
                                          message: t("PasswordMin"),
                                        },
                                        maxLength: {
                                          value: 20,
                                          message: t("PasswordMax"),
                                        },
                                      })}
                                      type={!showPassword ? "text" : "password"}
                                    />
                                  </div>
                                  <div
                                    onClick={() => handleShow()}
                                    className="v-input__append-inner"
                                  >
                                    <button
                                      type="button"
                                      style={{ color: "black" }}
                                      className={`v-icon notranslate v-icon--link mdi ${
                                        showPassword ? "mdi-eye" : "mdi-eye-off"
                                      } theme--light`}
                                    />
                                  </div>
                                </div>
                                {errors.password && errors.password.message && (
                                  <div className="v-text-field__details">
                                    <div
                                      className="v-messages theme--light error--text"
                                      role="alert"
                                    >
                                      <div className="v-messages__wrapper">
                                        <div className="v-messages__message">
                                          {errors.password.message}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{ margin: "10px 0" }}
                        className="row hidden-sm-and-down no-gutters"
                      >
                        <div className="col col-12">
                          <button
                            type="submit"
                            className="primary-button desktop-login-btn theme-button text-capitalize pa-2 v-btn v-btn--has-bg theme--light v-size--default black"
                            style={{
                              height: "auto",
                              "min-height": "50px",
                              color: "black",
                            }}
                          >
                            <span className="v-btn__content">{t("Login")}</span>
                          </button>
                        </div>
                        <div className="text-center col col-12">
                          <label
                            className="red--text subtitle-2"
                            style={{ display: "none" }}
                          />
                          <label
                            className="red--text subtitle-2"
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                      {/* <div className="row mb-1 no-gutters">
                        <div className="col col-12 text-right forgot-password">
                          <button
                            type="button"
                            className="text-capitalize body-3 text-decoration-underline v-btn v-btn--text theme--light v-size--default pr-0 title_color2--text font-weight-bold"
                            style={{ height: "auto" }}
                          >
                            <span className="v-btn__content">
                              Forgot password
                            </span>
                          </button>
                        </div>
                      </div> */}
                      <div
                        style={{ margin: "8px 0" }}
                        className="row hidden-md-and-up no-gutters"
                      >
                        <div className="col col-12">
                          <button
                            type="submit"
                            className="primary-button theme-button text-capitalize pa-2 font-weight-bold yellow--text v-btn v-btn--has-bg theme--light v-size--default black mobile-login-btn"
                            style={{ height: "auto" }}
                          >
                            <span className="v-btn__content">{t("Login")}</span>
                          </button>
                        </div>
                        <div className="text-center col col-12">
                          <label
                            className="red--text subtitle-2"
                            style={{ display: "none" }}
                          />
                          <label
                            className="red--text subtitle-2"
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                      <div className="row hidden-sm-and-down no-gutters">
                        <div className="col col-12">
                          <p className="input-field-label desktop-register text-center ma-0">
                            <label>{t("DontHaveAccountYet")}</label>
                            <label
                              onClick={() => navigate("/register")}
                              className=" forgot-text text-decoration-underline"
                            >
                              {t("RegisterHere")}
                            </label>
                          </p>
                        </div>
                      </div>
                      <div className="row no-gutters py-6">
                        <div className="col col-12">
                          <hr
                            role="separator"
                            aria-orientation="horizontal"
                            className="v-divider theme--light dialog-divider"
                          />
                        </div>
                      </div>
                      <div className="row hidden-md-and-up no-gutters">
                        <div className="col col-12">
                          <label className="input-field-label ma-0 pb-1 d-block title_color2--text">
                            {t("DontHaveAccountYet")}
                          </label>
                        </div>
                      </div>
                      <div
                        onClick={() => navigate("/register")}
                        className="row pb-10 hidden-md-and-up no-gutters"
                      >
                        <div className="col col-12">
                          <button
                            data-v-1dea3caa
                            type="button"
                            className="full-width font-weight-bold pa-2 dialog-button v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default buttonPrimary theme-button theme--light subtitle-1"
                          >
                            <span className="v-btn__content">
                              {t("Singup")}
                            </span>
                          </button>
                        </div>
                      </div>
                      <div className="row hidden-sm-and-down px-2 no-gutters">
                        <div className="col col-12">
                          <label className="login-tnc text-center ma-0 pb-1 d-block">
                            {t("LoginContactSupport")}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
          <div data-v-c5353408 role="dialog" className="v-dialog__container">
            {/**/}
          </div>
        </div>{" "}
      </div>
    </Layout>
  );
};

export default Login;
